export const tipoMovimentoData = [
  {
    value: 0,
    label: 'CI - Saída'
  },
  {
    value: 1,
    label: 'CI - Entrada'
  },
  {
    value: 2,
    label: 'Nota Fiscal'
  }
]
